var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6.75H28.8998C29.5073 6.75 30 7.24275 30 7.85025V22.1498C30 22.7572 29.5073 23.25 28.8998 23.25H18V6.75Z",
    fill: "#1976D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 10.4685H18V22.125H28.5V10.4685Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 30L0 26.625V3.375L17.25 0V30Z",
    fill: "#1976D2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 9.375C6.0555 9.375 4.125 11.8935 4.125 15C4.125 18.1065 6.0555 20.625 8.4375 20.625C10.8195 20.625 12.75 18.1065 12.75 15C12.75 11.8935 10.8195 9.375 8.4375 9.375ZM8.25 18.375C7.00725 18.375 6 16.8637 6 15C6 13.1363 7.00725 11.625 8.25 11.625C9.49275 11.625 10.5 13.1363 10.5 15C10.5 16.8637 9.49275 18.375 8.25 18.375Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0602 19.3027H18.0352V21.4777H20.0602V19.3027Z",
    fill: "#1976D2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6109 19.3027H20.5859V21.4777H22.6109V19.3027Z",
    fill: "#1976D2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1617 19.3027H23.1367V21.4777H25.1617V19.3027Z",
    fill: "#1976D2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0602 16.6191H18.0352V18.7941H20.0602V16.6191Z",
    fill: "#1976D2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6109 16.6191H20.5859V18.7941H22.6109V16.6191Z",
    fill: "#1976D2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1617 16.6191H23.1367V18.7941H25.1617V16.6191Z",
    fill: "#1976D2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7125 16.6191H25.6875V18.7941H27.7125V16.6191Z",
    fill: "#1976D2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0602 14.0295H18.0352V16.2045H20.0602V14.0295Z",
    fill: "#1976D2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6109 14.0295H20.5859V16.2045H22.6109V14.0295Z",
    fill: "#1976D2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1617 14.0295H23.1367V16.2045H25.1617V14.0295Z",
    fill: "#1976D2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7125 14.0295H25.6875V16.2045H27.7125V14.0295Z",
    fill: "#1976D2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6109 11.334H20.5859V13.509H22.6109V11.334Z",
    fill: "#1976D2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1617 11.334H23.1367V13.509H25.1617V11.334Z",
    fill: "#1976D2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7125 11.334H25.6875V13.509H27.7125V11.334Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlook);
export default __webpack_public_path__ + "static/media/outlook.7e1b077ec865bf871a48422ee7556ff3.svg";
export { ForwardRef as ReactComponent };